export function createAuthWorker(): Worker {
    return new Worker(
        new URL("./UpdateAuthenticationTokens", import.meta.url),
    );
}
